module.exports = __webpack_public_path__ + "static/media/paper-2.7b0190b7.png";